module.exports = __webpack_public_path__ + "static/img/8.099edc8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/zh/8.png
// module id = qktQ
// module chunks = 0